import axios from "axios";

export const ADD_PRODUCT_REQUEST = "ADD_PRODUCT_REQUEST";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAILURE = "ADD_PRODUCT_FAILURE";

export const FETCH_PRODUCT_REQUEST = "FETCH_PRODUCT_REQUEST";
export const FETCH_PRODUCT_SUCCESS = "FETCH_PRODUCT_SUCCESS";
export const FETCH_PRODUCT_FAILURE = "FETCH_PRODUCT_FAILURE";

export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAILURE = "UPDATE_PRODUCT_FAILURE";

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILURE = "DELETE_PRODUCT_FAILURE";

export const addProductRequest = () => {
    return {
        type: ADD_PRODUCT_REQUEST,
    };
};

export const addProductSuccess = (productGroup) => {
    return {
        type: ADD_PRODUCT_SUCCESS,
        payload: productGroup,
    };
};

export const addProductFailure = (error) => {
    return {
        type: ADD_PRODUCT_FAILURE,
        payload: error,
    };
};

export const updateProductRequest = () => {
    return {
        type: UPDATE_PRODUCT_REQUEST,
    };
};

export const updateProductSuccess = (productGroup) => {
    return {
        type: UPDATE_PRODUCT_SUCCESS,
        payload: productGroup,
    };
};

export const updateProductFailure = (error) => {
    return {
        type: UPDATE_PRODUCT_FAILURE,
        payload: error,
    };
};

export const deleteProductRequest = () => {
    return {
        type: DELETE_PRODUCT_REQUEST,
    };
};

export const deleteProductSuccess = (productGroup) => {
    return {
        type: DELETE_PRODUCT_SUCCESS,
        payload: productGroup,
    };
};

export const deleteProductFailure = (error) => {
    return {
        type: DELETE_PRODUCT_FAILURE,
        payload: error,
    };
};

export const fetchProductRequest = () => {
    return {
        type: FETCH_PRODUCT_REQUEST,
    };
};

export const fetchProductSuccess = (productGroup) => {
    return {
        type: FETCH_PRODUCT_SUCCESS,
        payload: productGroup,
    };
};

export const fetchProductFailure = (error) => {
    return {
        type: FETCH_PRODUCT_FAILURE,
        payload: error,
    };
};

export const addProductGroup = (data) => {
    return async (dispatch) => {
        dispatch(addProductRequest());
        axios.post("/create-product-group", data)
            .then(response => {
                dispatch(addProductSuccess(response.data));
            })
            .catch(error => {
                dispatch(addProductFailure(error.message));
            });
    };
};

export const updateProductGroup = (data) => {
    return async (dispatch) => {
        dispatch(updateProductRequest());
        axios.post("/update-product-group", data)
            .then(response => {
                dispatch(updateProductSuccess(response.data));
            })
            .catch(error => {
                dispatch(updateProductFailure(error.message));
            });
    };
};

export const deleteProductGroup = (data) => {
    return async (dispatch) => {
        dispatch(deleteProductRequest());
        axios.post("/delete-product-group", data)
            .then(response => {
                dispatch(deleteProductSuccess(response.data));
            })
            .catch(error => {
                dispatch(deleteProductFailure(error.message));
            });
    };
};

export const fetchProductGroup = () => {
    return async (dispatch) => {
        dispatch(addProductRequest());
        axios.get("/fetch-product-group")
            .then(response => {
                dispatch(fetchProductSuccess(response.data));
            })
            .catch(error => {
                dispatch(fetchProductFailure(error.message));
            });
    };
};